import { canEnableSwiperLoop } from './utils';

export default () => ({
    swiperLeft: null,
    swiperRight: null,
    init() {
        this.enable();
    },
    enable() {
        this.swiperLeft = new Swiper(this.$refs.leftSide, {
            slidesPerView: 1,
            spaceBetween: 15,
            pagination: false,
            loop: canEnableSwiperLoop(this.$refs.leftSide, { slidesPerView: 1 }),
            speed: 700,
            autoplay: {
                delay: 3999000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
        });
        const rightBreakpoints = {
            320: {
                slidesPerView: 1.25,
                pagination: false,
                spaceBetween: 9.375,
            },
            768: {
                slidesPerView: 1.2,
                pagination: false,
            },
        };

        this.swiperRight = new Swiper(this.$refs.rightSide, {
            slidesPerView: 1.2,
            spaceBetween: 15,
            pagination: false,
            loop: canEnableSwiperLoop(this.$refs.rightSide, { slidesPerView: 1.2, breakpoints: rightBreakpoints }),
            speed: 700,
            autoplay: {
                delay: 3000000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
            thumbs: {
                swiper: this.swiperLeft,
            },
            breakpoints: rightBreakpoints,
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.previous,
            },
        });
    },
});
